import React, { useState, useEffect, useCallback } from 'react';
import './orderdata.scss';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import OrderDialogEdit from './OrderDialogEdit';

const Orderdata = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(true);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;

  // ✅ FIX 1: useCallback
  const fetchtableTitle = useCallback(async (tableId) => {
    try {
      const storedToken = localStorage.getItem('accessToken');
      const response = await fetch(`${apiUrl}/tables/find/${tableId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          token: `Bearer ${storedToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const shopData = await response.json();
      return shopData.title;
    } catch (error) {
      console.error('Error fetching shop data:', error);
      return 'N/A';
    }
  }, [apiUrl]);

  // ✅ FIX 2: useCallback
  const updatetableTitles = useCallback(async (orderData) => {
    try {
      const tableTitlePromises = orderData.map(async (order) => {
        const title = await fetchtableTitle(order.tableId);
        return { ...order, tableTitle: title };
      });

      const ordersWithTitles = await Promise.all(tableTitlePromises);
      setRows(ordersWithTitles);
    } catch (error) {
      console.error('Error updating shop titles:', error);
    }
  }, [fetchtableTitle]);

  // ✅ FIX 3: useEffect dependency safe
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);

        const storedToken = localStorage.getItem('accessToken');

        const response = await fetch(
          `${apiUrl}/orders?page=${page + 1}&limit=${rowsPerPage}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const result = await response.json();

        const orderList = Array.isArray(result?.data) ? result.data : [];
        setRows(orderList);
        setTotalRows(result?.pagination?.total || 0);

        await updatetableTitles(orderList);
      } catch (error) {
        console.error('Error fetching data:', error);
        setRows([]);
        setTotalRows(0);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [apiUrl, page, rowsPerPage, updatetableTitles]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${date.getFullYear()}`;
  };

  return (
    <div>
      <TableContainer component={Paper} className="reporttable">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell>Order ID</TableCell>
                  <TableCell>SST</TableCell>
                  <TableCell>Service Charges</TableCell>
                  <TableCell>Amount (RM)</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row._id}>
                    <TableCell>{row._id}</TableCell>
                    <TableCell>{Number(row.sst || 0).toFixed(2)}</TableCell>
                    <TableCell>{Number(row.serviceCharge || 0).toFixed(2)}</TableCell>
                    <TableCell>{Number(row.grandTotal || 0).toFixed(2)}</TableCell>
                    <TableCell>{formatDate(row.createdAt)}</TableCell>
                    <TableCell>
                      <span className={`status ${row.status === 'pending' ? 'pending' : 'paid'}`}>
                        {row.status === 'pending' ? 'Pending' : 'Paid'}
                      </span>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setSelectedOrderId(row._id);
                          setEditDialogOpen(true);
                        }}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[10, 20, 30]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        )}
      </TableContainer>

      <OrderDialogEdit
        open={editDialogOpen}
        orderId={selectedOrderId}
        onClose={() => {
          setEditDialogOpen(false);
          setSelectedOrderId(null);
        }}
        onSave={(updatedOrder) => {
          setRows((prevRows) =>
            prevRows.map((row) => (row._id === updatedOrder._id ? updatedOrder : row))
          );
        }}
        apiUrl={apiUrl}
      />
    </div>
  );
};

export default Orderdata;